import { CheckCircle2 } from "lucide-react";
import { Checkbox } from "@/components/ui/checkbox";
import { cn, formatDate } from "@/lib/utils";
import { useTogglePartnerTask } from "../use-toggle-partner-task";
import type { OnboardingTaskRow } from "../use-partner-onboarding";

// Phase 7 sub-bucket 8 — port of /app/portal/onboarding/PartnerOnboardingItem.tsx.
//
// Legacy used a local useState(optimistic) + useTransition + router.refresh
// pattern. Pattern C optimism via `useTogglePartnerTask` (Phase 6 bucket 3)
// supersedes both: the hook flips the cached row's status synchronously, then
// invalidates on settle. The component renders directly off the cache via
// `task.status === "completed"` — no local mirror state needed.

export function PartnerOnboardingItem({ task }: { task: OnboardingTaskRow }) {
  const toggle = useTogglePartnerTask();
  const done = task.status === "completed";

  return (
    <li
      className={cn(
        "flex items-start gap-3 rounded-xl border bg-card px-5 py-4 transition",
        done && "bg-status-active/[0.04]",
      )}
    >
      <Checkbox
        checked={done}
        onCheckedChange={(next) =>
          toggle.mutate({ taskId: task.id, done: next === true })
        }
        disabled={toggle.isPending}
        className="mt-0.5"
      />
      <div className="min-w-0 flex-1">
        <div
          className={cn(
            "text-sm font-medium",
            done && "text-muted-foreground line-through decoration-status-active/50",
          )}
        >
          {task.title}
        </div>
        {task.description && (
          <p className="mt-1 text-xs text-muted-foreground">{task.description}</p>
        )}
        {task.due_date && (
          <p className="mt-1.5 text-[11px] text-muted-foreground">
            Due {formatDate(task.due_date)}
          </p>
        )}
      </div>
      {done && <CheckCircle2 className="h-4 w-4 shrink-0 text-status-active" />}
    </li>
  );
}
